import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import AdminCreateConsole from './AdminCreateConsole';
import ConsoleComponent from '../../components/Console/ConsoleComponent';
import { can, homeFor } from '../../permissions';

const Console = () => {
    const history = useNavigate();

    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;

    useEffect(() => {
        if (!userInfo) {
            history('/login?next=/console');
        } else if (!can(userInfo, 'console')) {
            history(homeFor(userInfo));
        }
    }, [userInfo, history]);

    if (!userInfo) {
        return null;
    }

    return (
        <>
            <Layout title="Console">
                <div className='flex flex-col lg:flex-row flex-grow lg:content-center lg:justify-center rounded-lg'>
                    {userInfo.isAdmin ? (
                        <>
                            <AdminCreateConsole />
                        </>
                    ) : (
                        <ConsoleComponent />
                    )}
                </div>
            </Layout>
        </>
    );
};

export default Console;
